import { css } from "@emotion/css";

/**
 * Meridian's Icon has no size prop — it renders at a fixed base size (24px for standard icons).
 * scaleIconClass returns an emotion class that scales an Icon by `factor` to hit a target size
 * without hard-coded width/height, e.g. scaleIconClass(1.67) ≈ 40px. Apply via the Icon's
 * `className`.
 */
export const scaleIconClass = (factor) =>
  css({ transform: `scale(${factor})` });
